import React, { useState } from 'react';
import { Button } from 'antd';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// Excel: имя листа ≤ 31 символа, без \ / ? * [ ] :, уникальное и непустое —
// иначе файл открывается с ошибкой «Файл поврежден»
const MAX_SHEET_NAME = 31;

const makeSheetNames = (lists = []) => {
  const used = new Set();
  return lists.map((list, index) => {
    const base =
      String(list.name || '')
        .replace(/[\\/?*[\]:]/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/^'+|'+$/g, '')
        .trim() || `Лист ${index + 1}`;

    let name = base.slice(0, MAX_SHEET_NAME).trim();
    for (let n = 2; used.has(name.toLowerCase()); n++) {
      const suffix = ` (${n})`;
      name = base.slice(0, MAX_SHEET_NAME - suffix.length).trim() + suffix;
    }
    used.add(name.toLowerCase());
    return name;
  });
};

const sanitizeFileName = (name) =>
  String(name || 'export')
    .replace(/[\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const toCellValue = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  return String(value);
};

const ExcelExport = ({ filename, lists = [], style }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (!lists.length) return;
    setLoading(true);
    try {
      const workbook = new ExcelJS.Workbook();
      const sheetNames = makeSheetNames(lists);

      lists.forEach((list, index) => {
        const sheet = workbook.addWorksheet(sheetNames[index]);
        const columns = list.columns || [];

        // полное название индикатора — в первой строке, т.к. имя листа обрезается
        const titleRow = sheet.addRow([String(list.name || '')]);
        titleRow.font = { bold: true };

        const headerRow = sheet.addRow(columns.map((c) => c.label));
        headerRow.font = { bold: true };

        (list.data || []).forEach((row) => {
          sheet.addRow(columns.map((c) => toCellValue(row[c.value])));
        });

        columns.forEach((_, i) => {
          sheet.getColumn(i + 1).width = 14;
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${sanitizeFileName(filename)}.xlsx`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      style={style}
      type="primary"
      loading={loading}
      disabled={!lists.length}
      onClick={handleExport}
    >
      Экспорт
    </Button>
  );
};

export default ExcelExport;
